import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from './cn.js';
const INPUT_CLASSES = 'flex h-11 w-full rounded-md border border-input bg-card px-3 py-2 text-sm text-foreground ' +
    'placeholder:text-muted-foreground transition-colors duration-[var(--dur-quick)] ' +
    'file:border-0 file:bg-transparent file:text-sm file:font-medium ' +
    'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 focus-visible:border-ring ' +
    'aria-[invalid=true]:border-destructive aria-[invalid=true]:focus-visible:ring-destructive ' +
    'disabled:cursor-not-allowed disabled:bg-disabled disabled:text-disabled-foreground ' +
    'disabled:outline-1 disabled:-outline-offset-1 disabled:outline-disabled-foreground';
/** Token-driven text input. AA focus ring; aria-invalid repaints the border. */
export const Input = forwardRef(({ className, type, ...props }, ref) => (_jsx("input", { ref: ref, type: type ?? 'text', className: cn(INPUT_CLASSES, className), ...props })));
Input.displayName = 'Input';
